import SlsTracker from '@aliyun-sls/web-track-browser'

// SLS配置 - 从环境变量读取
const getSlsConfig = () => {
  const env = process.env.VUE_APP_ENV || 'test'

  return {
    host: process.env.VUE_APP_SLS_HOST || '', // 所在地域的服务入口，例如：cn-hangzhou.log.aliyuncs.com
    project: process.env.VUE_APP_SLS_PROJECT || '', // Project名称
    logstore: process.env.VUE_APP_SLS_LOGSTORE || '', // Logstore名称
    topic: process.env.VUE_APP_SLS_TOPIC || 'pre-education-m-h5', // 自定义日志主题
    source: process.env.VUE_APP_SLS_SOURCE || 'app-wz-h5', // 自定义日志来源
    tags: {
      tags: process.env.VUE_APP_SLS_TAGS || 'app-wz-tags',
      env: env // 环境标识
    }
  }
}

// 创建 SLS Tracker 实例
let trackerInstance = null

export const getTracker = () => {
  if (!trackerInstance) {
    const opts = getSlsConfig()
    // 只有在配置完整的情况下才创建实例
    if (opts.host && opts.project && opts.logstore) {
      try {
        trackerInstance = new SlsTracker(opts)
      } catch (error) {
        console.warn('SLS Tracker 初始化失败:', error)
      }
    } else {
      console.warn('SLS 配置不完整，请检查环境变量文件（.env.test、.env.testing、.env.production）中的 SLS 配置')
    }
  }
  return trackerInstance
}

export default getTracker
